import React, {forwardRef} from 'react'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../helpers'
import {ModalInterface} from './types'

const Modal = forwardRef<HTMLDivElement, ModalInterface>(
    ({
         button: {bg, icon: {show, svg}, text, tooltip},
         modal: {id, size, content},
     },
     ref) => {

        const modalTarget = `kt_modal_${id}`

        return (
            <>
                <div className="text-center">
                    <Whisper placement="top" controlId="control-id-hover" trigger="hover"
                             speaker={<Tooltip>{tooltip}</Tooltip>}>
                        <button type="button"
                                className={`btn btn-sm btn-flex ${text ? `btn-light-${bg}` : `btn-icon btn-active-light-${bg}`} btn-active-${bg}`}
                                data-bs-toggle="modal"
                                data-bs-target={`#${modalTarget}`}
                        >
                            {show && (
                                <KTSVG
                                    path={`/media/icons/duotune/${svg}.svg`}
                                    className={`svg-icon svg-icon-3 svg-icon-${bg} ${text ? '' : 'me-0'}`}
                                />
                            )}
                            {text}
                        </button>
                    </Whisper>
                </div>
                <div className="modal fade" id={`${modalTarget}`} aria-hidden="true" ref={ref}>
                    <div className={`modal-dialog modal-dialog-centered modal-${size}`}>
                        <div className="modal-content">
                            {content}
                        </div>
                    </div>
                </div>
            </>
        )
    },
)

export {Modal}